var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      staticClass: "no-border",
      attrs: {
        id: "select-application-status-search",
        "no-label": "",
        label: _vm.$t("global.words.search").toString(),
        "hidden-label": "",
      },
    },
    [
      _c("v-select-field", {
        staticClass: "search-input w-100",
        attrs: {
          options: _vm.applicationStatusOptions,
          placeholder: _vm.$t("global.actions.chooseOption").toString(),
          label: "text",
          clearable: _vm.clearable,
          "default-value": _vm.localSelectedApplicationStatus,
          multiple: "",
          "has-checkboxes": "",
          "deselect-from-dropdown": "",
          action: _vm.actionRef,
          scenario: "applicationStatus",
        },
        on: {
          "option:selected": _vm.handleChange,
          "option:deselected": _vm.handleChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }